export default "__VITE_ASSET__BMWhO5Xh__"